/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Flex,
  Icon,
  FlexProps,
  ScaleFade,
  Text,
  useColorModeValue,
  Box,
  useDisclosure,
  Collapse,
} from '@chakra-ui/react';
import { GoDotFill } from 'react-icons/go';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

interface NavItemProps extends FlexProps {
  icon: any;
  parentName: string;
  childrenMenus: any;
  openMenu: boolean;
}

export function NavItemMenu({ icon, parentName, childrenMenus, openMenu, ...rest }: NavItemProps) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { isOpen, onToggle } = useDisclosure();
  const slugify = (value: string) =>
    value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)+/g, '');
  const parentTestId = `sidebar-parent-${slugify(parentName)}`;

  return (
    <Box>
      <Flex
        transition="0.2s"
        w="full"
        cursor="pointer"
        align="center"
        _hover={{ bg: 'gray.100' }}
        onClick={onToggle}
        data-testid={parentTestId}
        {...rest}
      >
        <Flex
          w={openMenu ? '80%' : '95%'}
          cursor="pointer"
          p="8px 0 8px 15px"
          align="center"
          my="4px"
        >
          <Icon
            mr={openMenu ? '30px' : '0px'}
            w="25px"
            h="25px"
            as={icon}
            color={useColorModeValue('text.light.primary', 'text.dark.primary')}
          />
          <ScaleFade in={openMenu} initialScale={0.5}>
            <Text
              minW="95px"
              color={useColorModeValue('text.light.primary', 'text.dark.primary')}
              fontFamily="heading"
              fontWeight="600"
            >
              {parentName}
            </Text>
          </ScaleFade>
        </Flex>
        <Icon w="20px" h="20px" as={isOpen ? ChevronUpIcon : ChevronDownIcon} />
      </Flex>
      <Collapse in={isOpen && openMenu} animateOpacity>
        {childrenMenus.map((submenu) => {
          const childTestId = `sidebar-child-${slugify(submenu.name)}`;
          return (
            <Flex
              key={submenu.name}
              w="full"
              p={
                pathname === submenu.path || pathname.includes(`${submenu.path}/`)
                  ? '8px 0 8px 15px'
                  : '8px 0 8px 70px'
              }
              my="4px"
              cursor="pointer"
              _hover={{ bg: 'gray.100' }}
              onClick={() => navigate(submenu.path)}
              data-testid={childTestId}
            >
              {(pathname === submenu.path || pathname.includes(`${submenu.path}/`)) && (
                <Icon
                  mr="30px"
                  w="25px"
                  h="25px"
                  as={GoDotFill}
                  color={
                    pathname === submenu.path || pathname.includes(`${submenu.path}/`)
                      ? useColorModeValue('text.light.secondary', 'text.dark.secondary')
                      : useColorModeValue('text.light.primary', 'text.dark.primary')
                  }
                />
              )}
              <Text
                minW="95px"
                color={
                  pathname === submenu.path || pathname.includes(`${submenu.path}/`)
                    ? useColorModeValue('text.light.secondary', 'text.dark.secondary')
                    : useColorModeValue('text.light.primary', 'text.dark.primary')
                }
                fontFamily="heading"
                fontWeight={
                  pathname === submenu.path || pathname.includes(`${submenu.path}/`)
                    ? 'bold'
                    : 'normal'
                }
              >
                {submenu.name}
              </Text>
            </Flex>
          );
        })}
      </Collapse>
    </Box>
  );
}
